
import EditaDatosProfesional from "../../../components/bodyBlocks/profesionalBlock/editarProfesional/EditaDatosProfesional";
import '../../../index.css';

const EditaDatoProfesional = () => {
  /* const { profesion = "", username = "" } = useParams<{ profesion: string; username: string }>(); */

  return (
    <div className="pt-14">
      <EditaDatosProfesional />
    </div>
  );
};

export default EditaDatoProfesional;
